import AuthorizationLocalStore from 'frontcore/domain/authorization/store/AuthorizationLocalStore'
import AuthorizationSSORedirectStorageImpl from 'frontcore/domain/authorization/store/AuthorizationSSORedirectStore'
import PermissionSSORedirectStorageImpl from 'frontcore/domain/authorization/store/PermissionSSORedirectStorage'
import PermissionStorageImpl from 'frontcore/domain/authorization/store/PermissionStorage'
import {
  AuthorizationSSORedirectStorage,
  AuthorizationStorage,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'
import {
  PermissionSSORedirectStorage,
  PermissionStorage,
} from 'frontcore/domain/authorization/model/PermissionService.d'

export class AuthorizationStorageFactory {
  static build (): AuthorizationStorage {
    return new AuthorizationLocalStore()
  }
}

export class AuthorizationSSORedirectStorageFactory {
  static build (): AuthorizationSSORedirectStorage {
    return new AuthorizationSSORedirectStorageImpl()
  }
}

export class PermissionStorageFactory {
  static build (): PermissionStorage {
    return new PermissionStorageImpl()
  }
}

export class PermissionSSORedirectStorageFactory {
  static build (): PermissionSSORedirectStorage {
    return new PermissionSSORedirectStorageImpl()
  }
}
